/**
 * Converts sort parametrs with "-" between into an object with name and sort type.
 *
 *
 * @param sort sort parameter
 * @returns - object with name as property and sortType as its value.
 *
 * @example
 * sortToObject("name-asc") // {name: "asc"}
 */
const sortToObject = (sort: string) => {
  const [sortBy, sortingOrder] = sort.split('-')

  return { sortBy, sortingOrder: sortingOrder.toUpperCase() }
}

export { sortToObject }
